import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import { ResponseType } from "../../Types/ServicesType/servicesType";
import {
  LabSearchPayoad,
  LabItemType,
  LabTemplateType,
  LabResultType,
  AbnormalFlagType,
  LabDataType,
  LabListResponseType,
} from "./type";
import instance from "@services/services";

const {clinicId, createdById} = getConstants()

const { LabApi, whatsappApi } = api;

export type SendLabRadiologyReportPayload = {
  reportType: "LAB" | "RADIOLOGY";
  encounterId: number;
  reqId: number;
};

export const getLabSearch = async (
  body: LabSearchPayoad
): Promise<
  ResponseType<{
    items: LabListResponseType[];
    totalCount: number;
    allPerformed: boolean;
  }>
> => {
  const result = await instance.post(`${LabApi.getLabSearch}`, {
    ...body,
    clinicId,
  });
  return result.data;
};

export const getLabItemList = async (
  id: string
): Promise<ResponseType<LabItemType[]>> => {
  const result = await instance.get(
    `${LabApi.getLabitemList}${id}?clinicId=${clinicId}`
  );
  return result.data;
};

export const getLabTemplates = async (
  data: LabItemType
): Promise<ResponseType<LabTemplateType[]>> => {
  const body = {
    templateName: data.name,
    labRequestId: data.labId,
    packageMappingId: data.cptId,
    cptId: data.cptId,
    clinicId,
  };
  const result = await instance.post(LabApi.getTemplates, body);
  return result.data;
};

export const getLabResult = async (data: {
  labId: number;
  pageNo: number;
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
}): Promise<
  ResponseType<{ labItems: LabResultType[]; totalCount: number }>
> => {
  const result = await instance.post(LabApi.getLabResult, {
    ...data,
    clinicId,
  });
  return result.data;
};

export const getAbnormalFlag = async (): Promise<
  ResponseType<AbnormalFlagType[]>
> => {
  const result = await instance.get(LabApi.getAbnormalFlag);
  return result.data;
};

export const saveLabResult = async (
  data: LabDataType[]
): Promise<ResponseType<string>> => {
  const result = await instance.post(LabApi.saveLabResult, data);
  return result.data;
  // console.log(data)
  // return {
  //   response:"",
  //   responseIndicator:"success",
  //   responseMessage:"success",
  //   statusCode:"200"
  // }
};

export const getLabReport = async (
  encounterId: string
): Promise<ResponseType<string>> => {
  return (
    await instance.post(LabApi.getLabReportPdf, {
      clinicId,
      encounterId: Number(encounterId),
    })
  ).data;
};

export const getLabReportbyid = async (labId:number):Promise<ResponseType<string>>=>{
   const result = await instance.get(`${LabApi.getLabReportPdf}${labId}?clinicId=${clinicId}`)
   return result.data
}

export const uploadResultDocument = async (body: {
  data: {
    _isEditMode: boolean;
    _isNew: boolean;
    _isUpdated: boolean;
    _isDeleted: boolean;
    _prevState: null | number | boolean | string;
    _defaultFieldName: string;
    _userId: number;
    labRequestId?: number;
    radioRequestId?: number;
    id: number;
    encounterId: number;
    groupId: number;
    isDashBoard?: 0 | 1;
    uploadFlag?:number
  };
  file: File;
}) => {
  const formData = new FormData();
  formData.append(
    "data",
    JSON.stringify({
      ...body.data,
      uploadFlag:body?.data?.uploadFlag || 0,
      isDashBoard: body.data.isDashBoard || 0,
      clinicId,
      createdById,
    })
  );
  console.log(body)
  formData.append("file", body.file);
  const { user } = getConstants();
  const isQatarRegion = user?.region.toLowerCase() === "qatar_region";
  const result = await instance.post(
    `${isQatarRegion ? LabApi.uploadLabResultFileV2 : LabApi.uploadLabResultFile}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return result.data;
};

export const getLabUploadedFiles = async (
  labId: number
): Promise<ResponseType<{ fileName: string; resultId: number }[]>> => {
  const result = await instance.get(
    `${LabApi.getUploadedFiles}${labId}?clinicId=${clinicId}`
  );
  return result.data;
};

export const getUploadFile = async (data: {
  requestId: number; //labrequestId
  encounterId: number;
  cptGrpId: 1 | 2;
  id: number;
  isDashBoard: 0 | 1;
  filePath?:string
}): Promise<ResponseType<string>> => {
  const result = await instance.post(`${LabApi.getUploadedFile}`, {
    ...data,
    clinicId,
  });
  return result.data;
};

export const sendLabRadiologyReport = async (
  payload: SendLabRadiologyReportPayload,
): Promise<ResponseType<null>> => {
  const result = await instance.post(whatsappApi.sendLabRadiologyReport, {
    ...payload,
    clinicId,
  });
  return result.data;
};
